import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Card from '../../shared/card';
import MentorContent from '../../components/mentor-card/mentor-content';
import MentorHeader from '../../components/mentor-card/mentor-header';
import { ReactComponent as DateSVG } from './assets/date.svg';
import { ReactComponent as TimeSVG } from './assets/time.svg';
import { useStylesRebookMentor } from './styles';

interface RebookMentorProps {
  name?: string;
  education?: string;
  profileImage?: string;
  lastBookedDate?: string;
  lastBookedTime?: string;
  mentorId?: string;
}

const RebookMentor = ({
  name,
  education,
  profileImage = '',
  lastBookedDate,
  lastBookedTime,
  mentorId,
}: RebookMentorProps) => {
  const classes = useStylesRebookMentor();
  const { t } = useTranslation();

  const history = useHistory();

  const handleOpenMentorDrawer = () => {
    history.push(`?mentorId=${mentorId}`);
  };

  return (
    <Card
      header={<MentorHeader profileImage={profileImage} />}
      onClick={handleOpenMentorDrawer}
      wrapperClassName={classes.rebookWrapper}
      content={
        <MentorContent
          name={name}
          education={education}
          sections={[
            {
              key: 'lastBooked',
              title: t(
                'v2.dashboard.individualCalls_card_bookAgainWithSameMentor_label_lastBookedCall',
              ),
              className: classes.lastBookedWrapper,
              children: (
                <Box className={classes.lastBooked}>
                  <Typography>
                    <DateSVG className={classes.lastBookedIcon} />
                    {lastBookedDate}
                  </Typography>
                  <Typography>
                    <TimeSVG className={classes.lastBookedIcon} />
                    {lastBookedTime}
                  </Typography>
                </Box>
              ),
            },
          ]}
        />
      }
      ctaLabel={t('v2.global.button_openProfile')}
      type="mentor"
    />
  );
};

export default RebookMentor;
